export const ACCESSES = [
  {
    id: 1,
    name: 'Parking',
  },
  {
    id: 2,
    name: 'Mobility Allowance',
  },
  {
    id: 0,
    name: 'Off site',
  },
];


export const CLAIMACCESSES = [
  {
    id: 1,
    name: "CLAIMS.CLAIM_FORM.OPTION.PARKING",
    circuitType:"Parking"
  },
  {
    id: 2,
    name: "CLAIMS.CLAIM_FORM.OPTION.ON_SITE",
    circuitType:"Office"
  },
  {
    id: 0,
    name: "CLAIMS.CLAIM_FORM.OPTION.OFF_SITE",
    circuitType:"Undefined"
  },
];